import { changeOperUserRoleTypes, setItem, getItem } from '@/utils/comUtils'

function setSessionId(result) {
  let _sessionId = result.getResponseHeader('session-id')
  if (_sessionId) {
    setItem('sessionId', _sessionId)
  }
}

function setCookie(xhr) {
  let _sessionId = getItem('sessionId')
  if (_sessionId) {
    xhr.setRequestHeader('session-id', _sessionId)
  }
}

function httpGet(url, data) {
  data = changeOperUserRoleTypes(data)
  return new Promise((resolve, reject) => {
    var xhr = window.XMLHttpRequest
      ? new window.XMLHttpRequest()
      : new window.ActiveXObject('Microsoft.XMLHttpRequest')
    // eslint-disable-next-line space-before-function-paren
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          setSessionId(xhr)
          var res = window.JSON.parse(xhr.responseText)
          if (res && res.result === '0') {
            resolve(res.data)
          } else if (res && res.result !== '0') {
            resolve(res)
          }
          reject(res)
        } else if (xhr.status === 401) {
          // 登录失效时 重新跳转到登录页
          window.location.hash = '#/'
        } else {
          reject(res)
        }
      }
    }
    var postData = []
    // eslint-disable-next-line space-before-function-paren
    window.Object.keys(data || {}).forEach(function (key) {
      postData.push(key + '=' + data[key])
    })
    url =
      !postData || postData === '' || postData.length === 0
        ? url
        : url + '?' + postData.join('&')

    xhr.open('GET', url, true)
    xhr.withCredentials = true // 允许跨域携带cookies
    setCookie(xhr)
    xhr.send(null)
  })
}

function httpPost(url, data) {
  data = changeOperUserRoleTypes(data)
  return new Promise((resolve, reject) => {
    var xhr = window.XMLHttpRequest
      ? new window.XMLHttpRequest()
      : new window.ActiveXObject('Microsoft.XMLHttpRequest')
    // eslint-disable-next-line space-before-function-paren
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          setSessionId(xhr)
          var res = window.JSON.parse(xhr.responseText)
          if (res && res.result === '0') {
            resolve(res.data)
          } else if (res && res.result !== '0') {
            resolve(res)
          }
          reject(res)
        } else if (xhr.status === 401) {
          // 登录失效时 重新跳转到登录页
          window.location.hash = '#/'
        } else {
          reject(res)
        }
      }
    }

    xhr.open('POST', url, true)
    xhr.withCredentials = true // 允许跨域携带cookies
    xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8')
    setCookie(xhr)
    xhr.send(JSON.stringify(data || {}))
  })
}

function uploadFile(url, data) {
  data = changeOperUserRoleTypes(data)
  return new Promise((resolve, reject) => {
    var xhr = window.XMLHttpRequest
      ? new window.XMLHttpRequest()
      : new window.ActiveXObject('Microsoft.XMLHttpRequest')
    // eslint-disable-next-line space-before-function-paren
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          setSessionId(xhr)
          var res = window.JSON.parse(xhr.responseText)
          if (res && res.result === '0') {
            resolve(res.data)
          }
          reject(res)
        } else if (xhr.status === 401) {
          // 登录失效时 重新跳转到登录页
          window.location.hash = '#/'
        } else {
          reject(res)
        }
      }
    }
    xhr.open('POST', url, true)
    xhr.withCredentials = true // 允许跨域携带cookies
    setCookie(xhr)
    xhr.send(data)
  })
}

function httpPut(url, data) {
  data = changeOperUserRoleTypes(data)
  return new Promise((resolve, reject) => {
    var xhr = window.XMLHttpRequest
      ? new window.XMLHttpRequest()
      : new window.ActiveXObject('Microsoft.XMLHttpRequest')
    // eslint-disable-next-line space-before-function-paren
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          setSessionId(xhr)
          var res = window.JSON.parse(xhr.responseText)
          if (res && res.result === '0') {
            resolve(res.data)
          }
          reject(res)
        } else if (xhr.status === 401) {
          // 登录失效时 重新跳转到登录页
          window.location.hash = '#/'
        } else {
          reject(res)
        }
      }
    }

    xhr.open('PUT', url, true)
    xhr.withCredentials = true // 允许跨域携带cookies
    // IE浏览器Ajax通信数据为空时，node服务端JSON解析会报错，必须传空对象
    setCookie(xhr)
    xhr.send(JSON.stringify(data || {}))
  })
}
function httpDelete(url, data) {
  data = changeOperUserRoleTypes(data)
  return new Promise((resolve, reject) => {
    var xhr = window.XMLHttpRequest
      ? new window.XMLHttpRequest()
      : new window.ActiveXObject('Microsoft.XMLHttpRequest')
    // eslint-disable-next-line space-before-function-paren
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          setSessionId(xhr)
          var res = window.JSON.parse(xhr.responseText)
          if (res && res.result === '0') {
            resolve(res.data)
          }
          reject(res)
        } else if (xhr.status === 401) {
          // 登录失效时 重新跳转到登录页
          window.location.hash = '#/'
        } else {
          reject(res)
        }
      }
    }

    xhr.open('DELETE', url, true)
    xhr.withCredentials = true // 允许跨域携带cookies
    // IE浏览器Ajax通信数据为空时，node服务端JSON解析会报错，必须传空对象
    setCookie(xhr)
    xhr.send(JSON.stringify(data || {}))
  })
}

function magicUploadFile(url, data) {
  return new Promise((resolve, reject) => {
    var xhr = window.XMLHttpRequest
      ? new window.XMLHttpRequest()
      : new window.ActiveXObject('Microsoft.XMLHttpRequest')
    // eslint-disable-next-line
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        var res = window.JSON.parse(xhr.responseText || { message: '服务异常' })
        if (xhr.status === 200) {
          setSessionId(xhr)
          if (res && res.result === '0') {
            resolve(res.data)
          } else {
            reject(res)
          }
        } else if (xhr.status === 401) {
          // 登录失效时 重新跳转到登录页
          window.location.hash = '#/'
        } else {
          res.message = '服务异常'
          reject(res)
        }
      }
    }
    xhr.open('POST', url, true)
    xhr.withCredentials = true // 允许跨域携带cookies
    xhr.setRequestHeader('Content-Type', 'multipart/form-data')
    setCookie(xhr)
    xhr.send(data)
  })
}

export default {
  get: httpGet,
  post: httpPost,
  put: httpPut,
  uploadFile,
  magicUploadFile,
  delete: httpDelete
}
